"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bank = void 0;
const definables_1 = require("definables");
class Bank extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._isOpen = false;
        this._toggledAt = null;
        this._imagePath = options.definition.imagePath;
    }
    get imagePath() {
        return this._imagePath;
    }
    get isOpen() {
        return this._isOpen;
    }
    get toggledAt() {
        if (this._toggledAt !== null) {
            return this._toggledAt;
        }
        throw new Error(this.getAccessorErrorMessage("toggledAt"));
    }
    set isOpen(isOpen) {
        this._isOpen = isOpen;
    }
    set toggledAt(toggledAt) {
        this._toggledAt = toggledAt;
    }
    hasToggledAt() {
        return this._toggledAt !== null;
    }
}
exports.Bank = Bank;
